// @flow

import React from 'react';
import { connect } from 'react-redux';
import DeliveryTime from '../../deliveryTime';
import { getDeliveryText } from '../../../store/componentSettings/selectors/carBlockSettings';

type StateProps = {|
  deliveryTime: string,
|};

type OwnProps = {|
  pdbId: string,
  blocksPerRow: number,
  variant: string,
|};

type Props = {|
  ...OwnProps,
  ...StateProps,
|};

const mapStateToProps = (state: any, { pdbId }: OwnProps): StateProps => ({
  deliveryTime: getDeliveryText(state, pdbId),
});

export default connect<any, OwnProps, StateProps, any, any, any>(
  mapStateToProps,
)(({ deliveryTime }: Props) => <DeliveryTime justify="center">{deliveryTime}</DeliveryTime>);
